import { useState, useEffect } from 'react';

const useScrollDirection = () => {
    const [scrollDirection, setScrollDirection] = useState('up');
    const [isAtTop, setIsAtTop] = useState(true);
    const [lastScrollY, setLastScrollY] = useState(0);

    useEffect(() => {
        const updateScrollDirection = () => {
            const scrollY = window.scrollY;
            const direction = scrollY > lastScrollY ? 'down' : 'up';
            const atTop = scrollY < 10; // Consider "at top" if within 10px of top

            // Only update if scroll direction has changed and we've scrolled more than 5px
            if (direction !== scrollDirection && Math.abs(scrollY - lastScrollY) > 5) {
                setScrollDirection(direction);
            }

            if (atTop !== isAtTop) {
                setIsAtTop(atTop);
            }

            setLastScrollY(scrollY > 0 ? scrollY : 0);
        };

        // Add event listener
        window.addEventListener('scroll', updateScrollDirection);

        // Initial check
        updateScrollDirection();

        // Cleanup
        return () => {
            window.removeEventListener('scroll', updateScrollDirection);
        };
    }, [scrollDirection, lastScrollY, isAtTop]);

    return { scrollDirection, isAtTop };
};

export default useScrollDirection;
